// extracted by mini-css-extract-plugin
export default {"img":"NotFoundPage_img__dQlY3","text":"NotFoundPage_text__rXQff"};